import { AttributesFacet } from '@/components/features/Search/Facets/AttributesFacet/AttributesFacet';
import { useFacets } from '@/components/features/Search/Facets/useFacets';
import { Accordion, Box, BoxProps, Button, Skeleton, VStack } from '@chakra-ui/react';
import useTranslation from 'next-translate/useTranslation';
import { rem } from 'polished';

type Props = {
  address: string;
} & BoxProps;

export const ActivityAttributeFilters = ({ address, ...props }: Props) => {
  const { t } = useTranslation('search');
  const { attributes, onClearFilters, isInitialLoading: isLoadingFacets } = useFacets(address);

  return (
    <Box {...props}>
      <Accordion as={VStack} spacing="space.8">
        {isLoadingFacets ? (
          <Skeleton h={rem(56)} w="full" />
        ) : (
          <AttributesFacet
            label={t('facets.attributes.label')}
            attributes={attributes}
            showCount={false}
          />
        )}
      </Accordion>
      <Box>
        <Button
          variant="link"
          onClick={onClearFilters}
          fontSize="sm"
          fontWeight="medium"
          pt="space.8"
        >
          {t('facets.actions.clear-all')}
        </Button>
      </Box>
    </Box>
  );
};
